module.exports = __webpack_public_path__ + "img/enterpriseContent.0442ec6a.jpg";